import BrowserFile from "../types/files/BrowserFile";

/* eslint-disable no-extend-native */
export {};
declare global {
    interface File {
        isTTSFile(): boolean;
        toBrowserFile(): Promise<BrowserFile>;
    }
}

if (!File.prototype.isTTSFile) {
    File.prototype.isTTSFile = function isTTSFile(this: File): boolean {
        return [
            ".sof9",
            ".tdf9",
            ".dof9",
            ".ptf9",
            ".sfx",
            ".tfx",
            ".zip",
        ].some(ext => this.name.toLowerCase().endsWith(ext));
    };
}

if (!File.prototype.toBrowserFile) {
    File.prototype.toBrowserFile = async function toBrowserFile(
        this: File,
    ): Promise<BrowserFile> {
        return {
            name: this.name,
            data: (await this.toDataUrl()).fromDataUrl(),
            mime: this.type,
            extn:
                this.name.lastIndexOf(".") > 0
                    ? this.name.substring(this.name.lastIndexOf("."))
                    : "",
        };
    };
}
